import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20.931 13.111a9 9 0 1 0 -9.453 7.874","key":"svg-0"}],["path",{"d":"M20 21l2 -2l-2 -2","key":"svg-1"}],["path",{"d":"M17 17l-2 2l2 2","key":"svg-2"}],["path",{"d":"M12 7v5l2 2","key":"svg-3"}]]

const IconClockCode = createReactComponent('outline', 'clock-code', 'ClockCode', __iconNode);

export default IconClockCode;